import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { durationValidators } from 'src/app/validators/duration.validators';
import { InputNumber } from 'primeng/inputnumber';
import { Subscription } from 'rxjs';
import { TransportFormService } from 'src/app/trip-calculator/services/transport-form.service';
import { ErrorComponent } from '../../../error/error.component';

@Component({
  selector: 'app-transport-duration-form',
  imports: [
    InputTextModule,
    TranslocoPipe,
    ReactiveFormsModule,
    InputNumber,
    ErrorComponent,
  ],
  templateUrl: './duration-form.component.html',
})
export class TransportDurationFormComponent implements OnInit, OnDestroy {
  transportFormService = inject(TransportFormService);
  fb = inject(FormBuilder);
  valueChangeSubscription?: Subscription;

  formGroup = this.fb.group(
    {
      hours: new FormControl<number | null>(null, [Validators.min(0)]),
      minutes: new FormControl<number | null>(null, [Validators.min(0)]),
    },
    {
      validators: [durationValidators()],
    },
  );
  ngOnInit() {
    this.transportFormService.createDurationControls();
    const duration =
      this.transportFormService.transportForm.get('duration')?.value;
    if (duration) {
      const hours = this.getHours(duration);
      const minutes = this.getMinutes(duration);
      this.formGroup.get('hours')?.setValue(hours);
      this.formGroup.get('minutes')?.setValue(minutes);
    }
    this.valueChangeSubscription = this.formGroup.valueChanges.subscribe(
      (value) => {
        const duration = this.getDuration(value.hours, value.minutes);
        this.transportFormService.transportForm
          .get('duration')
          ?.setValue(duration);
      },
    );
  }
  ngOnDestroy() {
    this.valueChangeSubscription?.unsubscribe();
  }

  private getDuration(
    hours: number | undefined | null,
    minutes: number | undefined | null,
  ): number | undefined {
    if (!hours && !minutes) {
      return undefined;
    }

    const hoursInDecimal = hours ?? 0;
    const minutesInDecimal = (minutes ?? 0) / 60;
    return hoursInDecimal + minutesInDecimal;
  }

  private getHours(duration: number | null | undefined): number | null {
    if (!duration) {
      return null;
    }
    return Math.floor(duration);
  }

  private getMinutes(duration: number | null | undefined): number | null {
    if (!duration) {
      return null;
    }
    const decimal = duration - Math.trunc(duration);
    return Math.round(decimal * 60);
  }
}
